<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row">
        <div class="col-md-3" @click="showTable(1)">
          <stats-card
            id="totalEmployers"
            title="Total Employers"
            type="gradient-red"
            :sub-title="totalEmployers"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>

        <div class="col-md-3" @click="showTable(2)">
          <stats-card
            id="totalPendingEmployers"
            title="Pending Employers"
            type="gradient-red"
            :sub-title="totalPendingEmployers"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>

        <div class="col-md-3" @click="showTable(3)">
          <stats-card
            id="totalApprovedEmployers"
            title="Approved Employers"
            type="gradient-red"
            :sub-title="totalApprovedEmployers"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>

        <div class="col-md-3" @click="showTable(4)">
          <stats-card
            id="totalRejectedEmployers"
            title="Rejected Employers"
            type="gradient-red"
            :sub-title="totalRejectedEmployers"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7" v-if="employers == true">
      <div class="row">
        <div class="col">
          <employers-table></employers-table>
        </div>
      </div>
    </div>

    <div class="container-fluid mt--7" v-if="pendingEmployers == true">
      <div class="row">
        <div class="col">
          <pending-employers-table></pending-employers-table>
        </div>
      </div>
    </div>

    <div class="container-fluid mt--7" v-if="approvedEmployers == true">
      <div class="row">
        <div class="col">
          <employers-by-status-table status="1"></employers-by-status-table>
        </div>
      </div>
    </div>

    <div class="container-fluid mt--7" v-if="rejectedEmployers == true">
      <div class="row">
        <div class="col">
          <employers-by-status-table status="2"></employers-by-status-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EmployersTable from "./Tables/EmployersTable";
import PendingEmployersTable from "./Tables/PendingEmployersTable";
import EmployersByStatusTable from "./Tables/EmployersByStatusTable";
import EventBus from "./../event-bus";
export default {
  name: "tables",
  components: {
    EmployersTable,
    PendingEmployersTable,
    EmployersByStatusTable
  },
  data() {
    return {
      totalEmployers: "0",
      totalPendingEmployers: "0",
      totalApprovedEmployers: "0",
      totalRejectedEmployers: "0",
      employers: true,
      pendingEmployers: false,
      approvedEmployers: false,
      rejectedEmployers: false
    };
  },
  mounted() {
    this.getTotalEmployer();
    this.getTotalPendingEmployer();
    this.getTotalApprovedEmployer();
    this.getTotalRejectedEmployer();

    EventBus.$on("updatePendingEmployerCount", () => {
      this.getTotalPendingEmployer();
      this.getTotalApprovedEmployer();
      this.getTotalRejectedEmployer();
    });

    EventBus.$on("updateEmployerCount", () => {
      this.getTotalEmployer();
    });

    $("#totalEmployers").addClass("bg-yellow");
    $("#totalPendingEmployers").removeClass("bg-yellow");
    $("#totalPendingEmployers .card-body .row .col .card-title").addClass(
      "text-muted"
    );
    $("#totalPendingEmployers .card-body .row .col .card-title").removeClass(
      "text-danger"
    );
    $("#userManagement").removeClass("collapse");
  },
  methods: {
    showTable(type) {
      this.$router.push({ query: { page: 1 } });
      if (type == 1) {
        this.employers = true;
        this.pendingEmployers = false;
        this.approvedEmployers = false;
        this.rejectedEmployers = false;

        $("#totalEmployers").addClass("bg-yellow");
        $("#totalPendingEmployers").removeClass("bg-yellow");
        $("#totalApprovedEmployers").removeClass("bg-yellow");
        $("#totalRejectedEmployers").removeClass("bg-yellow");
      } else if (type == 2) {
        this.employers = false;
        this.pendingEmployers = true;
        this.approvedEmployers = false;
        this.rejectedEmployers = false;

        $("#totalEmployers").removeClass("bg-yellow");
        $("#totalPendingEmployers").addClass("bg-yellow");
        $("#totalApprovedEmployers").removeClass("bg-yellow");
        $("#totalRejectedEmployers").removeClass("bg-yellow");
      } else if (type == 3) {
        this.employers = false;
        this.pendingEmployers = false;
        this.approvedEmployers = true;
        this.rejectedEmployers = false;

        $("#totalEmployers").removeClass("bg-yellow");
        $("#totalPendingEmployers").removeClass("bg-yellow");
        $("#totalApprovedEmployers").addClass("bg-yellow");
        $("#totalRejectedEmployers").removeClass("bg-yellow");
      } else if (type == 4) {
        this.employers = false;
        this.pendingEmployers = false;
        this.approvedEmployers = false;
        this.rejectedEmployers = true;

        $("#totalEmployers").removeClass("bg-yellow");
        $("#totalPendingEmployers").removeClass("bg-yellow");
        $("#totalApprovedEmployers").removeClass("bg-yellow");
        $("#totalRejectedEmployers").addClass("bg-yellow");
      }
    },

    getTotalEmployer() {
      this.$store
        .dispatch("fetchTotalEmployer", { status: 255 })
        .then(response => {
          this.totalEmployers = response.data.toString();
        });
    },

    getTotalPendingEmployer() {
      this.$store
        .dispatch("fetchTotalEmployer", { status: 0 })
        .then(response => {
          this.totalPendingEmployers = response.data.toString();
        });
    },

    getTotalApprovedEmployer() {
      this.$store
        .dispatch("fetchTotalEmployer", { status: 1 })
        .then(response => {
          this.totalApprovedEmployers = response.data.toString();
        });
    },

    getTotalRejectedEmployer() {
      this.$store
        .dispatch("fetchTotalEmployer", { status: 2 })
        .then(response => {
          this.totalRejectedEmployers = response.data.toString();
        });
    }
  }
};
</script>
<style></style>
